export var ScuffedTesting;
(function (ScuffedTesting) {
    class TestSet {
        constructor(name, sub_tests) {
            this.name = name;
            this.sub_tests = sub_tests;
        }
        run() {
            return run(this, 0);
        }
    }
    ScuffedTesting.TestSet = TestSet;
    function testset(name, ...tests) {
        return new TestSet(name, tests);
    }
    ScuffedTesting.testset = testset;
    async function run(test, indent = 0) {
        if (test instanceof TestSet) {
            console.log(`${" ".repeat(indent)}Running '${test.name}'`);
            let success = true;
            for (let sub of test.sub_tests) {
                success && (success = await run(sub, indent + 2));
            }
            console.log(`${" ".repeat(indent)}Result of '${test.name}' ${success ? "✓" : "FAILURE"}`);
            return success;
        }
        else {
            const success = await (async () => {
                try {
                    await test();
                    return true;
                }
                catch (e) {
                    return false;
                }
            })();
            console.log(`${" ".repeat(indent)}'Running ${test.name}': ${success ? "✓" : "FAILURE"}`);
            return success;
        }
    }
    ScuffedTesting.run = run;
    class TestFailedException extends Error {
        constructor() { super(); }
    }
    function fail() {
        debugger;
        throw new TestFailedException();
    }
    ScuffedTesting.fail = fail;
    function assert(b) {
        if (!b)
            fail();
    }
    ScuffedTesting.assert = assert;
    function assertEquals(a, b, epsilon = 0.000001) {
        assert(Math.abs(a - b) < epsilon);
    }
    ScuffedTesting.assertEquals = assertEquals;
})(ScuffedTesting || (ScuffedTesting = {}));
